<script setup lang="ts">
import Layout from '@/views/Layout/Layout.vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import locale from 'ant-design-vue/es/locale/it_IT'
import { ConfigProvider } from 'ant-design-vue'
import dayjs from 'dayjs'
import 'dayjs/locale/it-ch'
import ReportExportToasts from '@/js/components/ReportExport/ReportExportToasts.vue'

dayjs.locale('it-ch')

const route = useRoute()
const isLayoutAuth = computed(() => !route.meta.isProtected)
const hasGradientHeader = computed(() => route.meta.hasGradientHeader)
const noLayout = computed(() => route.meta.noLayout)
const hasReportExportToasts = computed(() => route.meta.isProtected && !noLayout.value)
</script>

<template>
    <ConfigProvider :locale="locale">
        <router-view v-slot="{ Component }">
            <div v-if="noLayout">
                <transition mode="out-in" name="fade">
                    <component :is="Component" />
                </transition>
            </div>
            <Layout v-else-if="!isLayoutAuth" :gradient-header="hasGradientHeader">
                <transition mode="out-in" name="fade">
                    <component :is="Component" />
                </transition>
            </Layout>
            <Layout v-else :gradient-header="hasGradientHeader" auth>
                <transition mode="out-in" name="fade">
                    <component :is="Component" />
                </transition>
            </Layout>
        </router-view>
        <ReportExportToasts v-if="hasReportExportToasts" />
    </ConfigProvider>
</template>
